var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapMarker',[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.event.materialIcon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }